import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubjectOverview from "./routes/SubjectOverview";
import StandardsElement from "./routes/StandardsElement";
import SubjectTimeline from "./routes/SubjectTimeline";
export default store => ({
  path: "curriculumMaps/:subjectId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "planning-insights" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    StandardsElement(store),
    SubjectOverview(store),
    SubjectTimeline(store),
  ],
});
